import {  
  Box, 
  Typography , 
  List , 
  ListItem , 
  ListItemButton, 
  Divider , 
  AppBar, 
  Toolbar , 
  IconButton ,  
  Drawer , 
  Grid , 
} from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import { HashLink as Link } from 'react-router-hash-link';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react'; 
import '../App.css';



function Welcome (props){
    const drawerWidth = 240;

    const {window}= props ;

    const styles = {
      style: {
          width : '100%' ,
          overflowX : 'hidden' ,
          color : 'black',
          backgroundColor : '#70706e' , 
          display : 'flex' , 
          height : '500px'
      }
  };
    // const { window } = props;
    const [mobileOpen , setMobileOpen] = useState(false)
    const handleDrawerToggle = () => {
      setMobileOpen(!mobileOpen);
    };

    const container = window !== undefined ? () => window().document.body : undefined;

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
          <Typography variant="h6" sx={{ my: 2 }}>
            Nadir Mesmoudi
          </Typography>
          <Divider />
          <List>
            
              <ListItem disablePadding>
                <ListItemButton sx={{ textAlign: 'center' }}>
                  <Link to='#skills'  style={{color : 'black' , alignItems : 'center' , cursor : 'pointer' , textDecoration : 'none' , marginLeft : '5em'}} smooth>
                          Skills
                  </Link>
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton sx={{ textAlign: 'center' }}>
                <Link to='#services'  style={{color : 'black' , alignItems : 'center' , cursor : 'pointer' , textDecoration : 'none' , marginLeft : '5em'}} smooth>
                          Services
                </Link>
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton sx={{ textAlign: 'center' }}>
                <Link to='#projects'  style={{color : 'black' , alignItems : 'center' , cursor : 'pointer' , textDecoration : 'none' , marginLeft : '5em'}} smooth>
                          Projects
                </Link>
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton sx={{ textAlign: 'center' }}>
                <Link to='#contact_me'  style={{color : 'black' , alignItems : 'center' , cursor : 'pointer' , textDecoration : 'none' , marginLeft : '5em'}} smooth>
                          Contact Me
                </Link>
                </ListItemButton>
              </ListItem>
           
          </List>
        </Box>
      );
   
    return(
        <Box>
        <Box style={styles.style}>
            <AppBar component="nav" style={{background : "transparent" , boxShadow : 'none'  , position : 'absolute'}}>
                <Toolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ mr: 2, display: { sm: 'none'  }  , color : 'white'}}
                >
                    <MenuIcon />
                </IconButton>
                <Typography
                    variant="h6"
                    component="div"
                    sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } , 
                    width : '100px'  , 
                    color : 'white'
                  }}
                >
                    Nadir Mesmoudi
                </Typography>
                <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    
                    <Link to='#skills'  style={{ color: 'white' , marginRight : "3em" , cursor : 'pointer' , textDecoration : 'none'}} smooth>
                        Skills
                    </Link>
                    <Link to='#services'  style={{ color: 'white' , marginRight : "3em" , cursor : 'pointer' , textDecoration : 'none'}} smooth>
                        Services
                    </Link>
                    <Link to='#projects'  style={{ color: 'white' , marginRight : "3em" , cursor : 'pointer' , textDecoration : 'none'}} smooth>
                        Projects
                    </Link>
                    <Link to='#contact_me'  style={{ color: 'white' , marginRight : "3em" , cursor : 'pointer' , textDecoration : 'none'}} smooth>
                        Contact Me
                    </Link>
                    
                    
                    
                </Box>
                </Toolbar>
            </AppBar>

            <Box component="nav" >
                  <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                      keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                      display: { xs: 'block', sm: 'none' },
                      '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                  >
                    {drawer}
                  </Drawer>
            </Box>

          <Grid  container style= {{ backgroundColor : '#70706e' , textAlign  : 'center' , marginTop : '6em'}}>
           
                    <Grid item xs={12} textAlign='center'>
                      <Typography 
                        variant='h4' 
                        textAlign='center' 
                        color='white'
                      >
                          Mohammed Nadir Mesmoudi
                      </Typography>
                    </Grid>
                    <Grid item xs={12} textAlign='center' marginLeft='20%' marginRight='20%' marginTop='-1em'>
                      <Typography 
                        textAlign='center' 
                        color='white'
                      >
                          Here is a quick overview of my skills and strengths . I am Front End Web Developer . Proficient in Html , CSS and JavaScript Frameworks (React JS) , plus modern libraries . I worked on some projects, including for study, mostly for fun.
                      </Typography>
                    </Grid>
                    <Grid item xs={12} textAlign='center' marginLeft='20%' marginRight='20%' >
                      <Link to='//www.github.com/nadircode' target='_blank'>
                      <IconButton 
                        aria-label="Github Account"
                        style={{
                          color : 'white' 
                        }}
                      >
                        <GitHubIcon style={{fontSize : '2em'}}/>
                      </IconButton>
                      </Link>
                    </Grid>
           
            
          </Grid>
          

        </Box>
        </Box>
    )
}

export default Welcome ;